import { CommitmentClassTabProps } from "features/commitment-classes/setup/CommitmentClassTabProps";
import { WaterfallConfigSummaryTable } from "features/waterfall/WaterfallConfigSummaryTable";
import { WaterfallEditForm } from "features/waterfall/WaterfallEditForm";
import {
  useWaterfallConfigRetrieveSuspense,
  useWaterfallConfigUpsert,
} from "gen/endpoints/waterfall/waterfall";
import { WaterfallConfigData } from "gen/model/waterfallConfigData";
import { useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { useBoolean } from "usehooks-ts";

export const CommitmentClassTabWaterfall: React.FC = () => {
  const { fundFamilyId, investorClassId } =
    useOutletContext<CommitmentClassTabProps>();

  const {
    value: isEditing,
    setTrue: startEditing,
    setFalse: stopEditing,
  } = useBoolean();
  const { data: waterfallData } = useWaterfallConfigRetrieveSuspense(
    fundFamilyId,
    {
      investor_class_id: investorClassId,
    },
  );
  const { mutateAsync: upsertWaterfallConfig } = useWaterfallConfigUpsert();

  const saveWaterfallConfig = useCallback(
    async (data: WaterfallConfigData) => {
      await upsertWaterfallConfig({
        fundFamilyId,
        data: {
          ...data,
          investor_class_id: investorClassId,
        },
      });
      stopEditing();
    },
    [upsertWaterfallConfig, fundFamilyId, investorClassId, stopEditing],
  );

  return (
    <PageTabBody>
      {!isEditing ? (
        <WaterfallConfigSummaryTable
          fundFamilyId={fundFamilyId}
          investorClassId={investorClassId}
          isEditing={isEditing}
          startEditing={startEditing}
        />
      ) : (
        <WaterfallEditForm
          fundFamilyId={fundFamilyId}
          waterfallData={waterfallData}
          saveWaterfallConfig={saveWaterfallConfig}
          onCancel={stopEditing}
        />
      )}
    </PageTabBody>
  );
};
